import React from 'react';
import moment from 'moment';

const Countdown = ({ targetDate }) => {
  const [time, setTime] = React.useState("");

  React.useEffect(() => {
    const interval = setInterval(() => {
      const total = moment(targetDate).diff(moment());

      if (total <= 0) {
        setTime("Expired");
        clearInterval(interval);
        return;
      }

      const duration = moment.duration(total);

      const days = Math.floor(duration.asDays());
      const hours = duration.hours();
      const minutes = duration.minutes();
      const seconds = duration.seconds();

      let parts = [];
      if (days > 0) parts.push(`${days}d`);
      if (hours > 0 || parts.length > 0) parts.push(`${hours}h`);
      if (minutes > 0 || parts.length > 0) parts.push(`${minutes}m`);
      parts.push(`${seconds}s`);

      setTime(parts.join(" "));
    }, 1000);

    return () => clearInterval(interval);
  }, [targetDate]);

  return <span>{time}</span>;
};

export default Countdown;